
<div class="pager">
  <div class="info" >
    @if (!loading && totalCount > 0) {
      <span>{{ pageFrom }} - {{ pageTo }} of {{totalCount}}</span>
    }
  </div>

  <button [disabled]="pageNum === 1 || loading" (click)="prevPage()">
    <i class="fa fa-chevron-left"></i>
  </button>
  <button [disabled]="pageNum * pageSize >= totalCount  || loading" (click)="nextPage()">
    <i class="fa fa-chevron-right"></i>
  </button>
</div>

@if (loading) {
  <mat-progress-bar  mode="indeterminate" color="primary"></mat-progress-bar>
}